(function(){
  // 1) Marcar como colapsadas todas las tarjetas que tengan "Ver más"
  const cards = document.querySelectorAll('.multicolumn .multicolumn-card');
  cards.forEach(card => {
    const link = card.querySelector('.multicolumn-card__info .rte a');
    if (!link) return;

    // Normalizamos el texto del link
    const txt = (link.textContent || '').trim().toLowerCase();
    if (txt === 'ver más' || txt === 'ver mas') {
      link.classList.add('omna-toggle');
      card.classList.add('is-collapsed'); // <-- estado inicial
      link.setAttribute('aria-expanded', 'false');
    }
  });

  // 2) Delegación: click en "Ver más / Ver menos"
  document.addEventListener('click', function(e){
    const a = e.target.closest('.omna-toggle');
    if (!a) return;

    e.preventDefault();
    const card = a.closest('.multicolumn-card');
    if (!card) return;

    const collapsed = card.classList.contains('is-collapsed');
    card.classList.toggle('is-collapsed', !collapsed);

    // Cambiar texto y accesibilidad
    const newLabel = collapsed ? 'Ver menos' : 'Ver más';
    a.textContent = newLabel;
    a.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
  });
})();
